export enum RewardType {
  UniverseCreation = 'universe_creation',
  CoinsStackL1 = 'coins_stack_l1',
  CoinsStackL2 = 'coins_stack_l2',
  Character = 'character_card',
  Event = 'event_card',
  VideoGeneration = 'video_generation',
}
